export default {
  agentTitle: 'Retail Ops Agent',
  taskActions: 'Task Control',
  workOrderPool: 'Orders',
  orderUnit: 'orders',
  orderManage: 'Manage',
  orderDetailTitle: 'Order detail',
  orderManageTitle: 'Order management',
  viewMoreOrders: 'View more',
  statusNew: 'New',
  startReplenish: 'Start Replenish',
  startTidy: 'Start Tidying',
  startReset: 'Reset inventory',
  cmdReplenish: 'Replenish',
  cmdTidy: 'Tidy',
  cmdReset: 'Reset',
  starting: 'Starting…',
  resetting: 'Resetting…',
  replenishSuccess: 'Replenish order created and added to the list',
  tidySuccess: 'Tidying order created and added to the list',
  resetSuccess: 'Inventory reset',
  replenishApiPending: 'Replenish API not connected yet',
  tidyApiPending: 'Tidying API not connected yet',
  startFailed: 'Failed to start task',
  statsTitle: 'Retail stats',
  statsScope: 'Today',
  pickedCount: 'Items sold',
  deliveredCount: 'Delivered',
  salesAmount: 'Sales',
  salesEstimated: 'est.',
  activeOrders: 'Active orders',
  completedOrders: 'Completed',
  pickupSuccessRate: 'Pickup success',
  servicePeople: 'People served',
  fastestDelivery: 'Fastest delivery',
  replenishToday: 'Replenish',
  tidyToday: 'Tidying',
  exceptionCount: 'Exceptions',
  viewExceptionList: 'View exception tasks',
  exceptionListTitle: 'Exception tasks',
  statViewHint: 'View',
  mileage: 'Autonomous mileage',
  peopleUnit: 'ppl',
  salesChartTitle: 'Sold items',
  salesChartEmptyTitle: 'No sales yet',
  salesChartEmptyHint: 'Sold items will show up here',
  topViewSwitch: 'Switch stats and cameras',
  topViewStats: 'Stats',
  topViewCamera: 'Cameras',
  sceneSwitch: 'Switch shelf and map',
  sceneShelf: 'Shelf',
  sceneMap: 'Map',
  mapTitle: 'Map',
  mapLegendCurrent: 'Current',
  mapLegendPath: 'Path',
  mapLegendStation: 'Station',
  mapLegendTarget: 'Target',
  mapLoadingTitle: 'Loading map',
  mapLoadingHint: 'Fetching occupancy grid…',
  statusTitle: 'Robot Status',
  statusNoData: 'No data',
  statusSn: 'SN: ',
  snSwitch: 'Switch device SN',
  snSwitchPlaceholder: 'Select device SN',
  statusSelfCheck: 'Self-check: ',
  statusInTask: 'On task: ',
  statusReady: 'Ready',
  statusNotReady: 'Not ready',
  statusYes: 'Yes',
  statusNo: 'No',
  statusBattery: 'Battery',
  statusCharging: 'Charging',
  statusNotCharging: 'Not charging',
  statusVoltage: 'Voltage',
  statusBatteryTemp: 'Battery temp',
  statusCycle: 'Cycles',
  statusTelemetry: 'Telemetry',
  statusHostTemp: 'Host temp',
  statusForwardSpeed: 'Forward speed',
  statusChassis: 'Chassis',
  statusRuntime: 'Uptime',
  statusMotion: 'Motion',
  statusStrafeSpeed: 'Strafe speed',
  statusAngularSpeed: 'Angular speed',
  statusControllerStopped: 'Controller stopped',
  statusNav: 'Navigation',
  statusNavPhase: 'Nav phase',
  statusTargetStation: 'Target station',
  statusPose: 'Pose',
  statusYaw: 'Heading',
  statusMove: 'Move',
  statusExpand: 'Expand',
  statusCollapse: 'Collapse',
  statusForward: 'Forward',
  statusBackward: 'Backward',
  statusLeft: 'Left',
  statusRight: 'Right',
  statusEstop: 'E-stop',
  statusMoving: 'Moving {dir}…',
  statusMoveDisabledHint: 'Direction pad disabled. E-stop is available.',
  statusMoveHint: 'Hold a direction to move, release to stop',
  statusMoveFailed: 'Move command failed',
  statusEstopSent: 'E-stop sent',
  statusEstopFailed: 'E-stop failed',
  statusChassisIdle: 'Idle',
  statusChassisMoving: 'Moving',
  statusChassisBlocked: 'Blocked',
  statusChassisEmergency: 'E-stop',
  statusChassisError: 'Fault',
  statusNavIdle: 'Idle',
  statusNavPending: 'Pending',
  statusNavActive: 'Navigating',
  statusNavPaused: 'Paused',
  statusNavSucceeded: 'Arrived',
  statusNavFailed: 'Failed',
  statusNavCancelled: 'Cancelled',
  replenishCount: 'Replenish count',
  tidyCount: 'Tidying count',
  viewReplenishList: 'View replenish list',
  viewTidyList: 'View tidying list',
  replenishListTitle: 'Replenish list',
  tidyListTitle: 'Tidying list',
  categoryCompleteness: 'Category completeness',
  orderProgress: 'Order fulfillment',
  itemsUnit: 'pcs',
  timesUnit: 'times',
  skuShortageTitle: 'SKU shortage alert',
  skuAdviceTitle: 'Replenish advice',
  viewReport: 'Traceable report',
  reportTitle: 'Task Trace Report',
  reportFilterAll: 'All orders',
  reportFilterStatusAll: 'All status',
  reportFilterDate: 'Select order date',
  reportSearchPlaceholder: 'Search ID / SKU / route',
  reportResultCount: '{n} results',
  reportTotalCount: '{n} total',
  reportEmpty: 'No task records yet',
  reportOrderProducts: 'Products',
  reportOrderQty: 'Quantity',
  reportOrderRoute: 'Route',
  reportProgress: 'Progress',
  reportCreatedAt: 'Ordered at',
  reportExpand: 'Expand',
  reportCollapse: 'Collapse',
  reportImages: 'Scene photos',
  reportImagesEmpty: 'No photos yet — will show here when available',
  reportAgentEvents: 'Execution process',
  reportNoEvents: 'No execution records',
  statusPending: 'Queued',
  statusInProgress: 'In progress',
  statusCompleted: 'Completed',
  statusAbnormal: 'Abnormal',
  orderTypePick: 'Pick',
  orderTypeReplenish: 'Replenish',
  orderTypeTidy: 'Tidy',
  taskTitleReplenish: 'Replenish task',
  taskTitleTidy: 'Tidying task',
  agentLive: 'Live',
  agentLatest: 'Latest',
  agentEmpty: 'Waiting for retail ops agent events…',
  agentNextStep: 'Next: ',
  reportCurrentAisle: 'Current aisle',
  shelfTitle: 'Shelf Layout',
  shelfDaily: 'Daily',
  shelfBeverage: 'Drinks',
  shelfSnack: 'Snacks',
  shelfLoading: 'Loading products…',
  shelfNoImage: 'No image',
  shelfInventory: 'Stock',
}
